import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
interface BlogCardProps {
  title: string;
  excerpt: string;
  slug: string;
  date: string;
  imageUrl?: string;
  className?: string;
  categories?: string[];
}
export function BlogCard({
  title,
  excerpt,
  slug,
  date,
  imageUrl,
  className,
  categories
}: BlogCardProps) {
  return <Link to={`/blog/${slug}`} className={cn("group flex flex-col overflow-hidden rounded-2xl bg-white border border-grandpal-beige shadow-sm hover:shadow-md transition-all duration-300", className)}>
      {imageUrl && <div className="relative h-52 overflow-hidden">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={e => {
        e.currentTarget.src = '/placeholder.svg';
      }} />
          {categories && categories.length > 0 && <div className="absolute bottom-4 left-4 flex flex-wrap gap-2">
              {categories.map(category => <span key={category} className="text-xs px-3 py-1 bg-white/90 backdrop-blur-sm text-grandpal-green-dark rounded-full shadow-sm">
                  {category}
                </span>)}
            </div>}
        </div>}
      <div className="flex-1 p-6">
        <h3 className="text-xl font-semibold mb-3 text-grandpal-green-dark group-hover:text-grandpal-green-dark transition-colors duration-200 line-clamp-2">
          {title}
        </h3>
        <p className="text-grandpal-gray mb-4 line-clamp-2">{excerpt}</p>
        <div className="flex justify-between items-center">
          <div className="flex items-center text-sm text-grandpal-gray">
            <Clock className="h-4 w-4 mr-1" />
            <span>{date}</span>
          </div>
          <span className="text-grandpal-green-dark flex items-center">
            Read more 
            <ArrowRight className="h-4 w-4 ml-1 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
          </span>
        </div>
      </div>
    </Link>;
}